export default "__VITE_ASSET__DVeGN4h7__"